import { render, staticRenderFns } from "./log-setting.vue?vue&type=template&id=0b1ddcf9&scoped=true"
import script from "./log-setting.vue?vue&type=script&lang=js"
export * from "./log-setting.vue?vue&type=script&lang=js"
import style0 from "./log-setting.vue?vue&type=style&index=0&id=0b1ddcf9&prod&lang=less&scoped=true"
import style1 from "./log-setting.vue?vue&type=style&index=1&id=0b1ddcf9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1ddcf9",
  null
  
)

export default component.exports